<template>
    <section>
        <div class="columns">
            <div class="column is-two-quarters">
                <b-field expanded
                         label="Dirección"
                         :type="errors.has('addressUserInput') ? 'is-danger' : ''"
                         :message="errors.first('addressUserInput')"
                >
                    <b-field>
                        <b-input expanded
                                 type="search"
                                 ref="address"
                                 v-model="addressUserInput"
                                 v-validate="'required'"
                                 placeholder="E.g. Callao 123, CABA"
                                 @blur="onSearchAddress">
                        </b-input>

                        <div class="control">
                            <button class="button is-primary" @click="onSearchAddress">Buscar</button>
                        </div>
                    </b-field>
                </b-field>

                <b-field>
                    <p class="address-info" v-if="hasValidAddress">
                        <span v-if="deliveryAddress.place">{{ deliveryAddress.place }}<br/></span>
                        <span v-if="deliveryAddress.address">{{ deliveryAddress.address }}<br/></span>
                    </p>
                </b-field>

                <b-field>
                    <b-field>
                        <b-field label="Unidad">
                            <b-input v-model="deliveryAddress.unit" placeholder="Piso, depto y/o unidad"></b-input>
                        </b-field>
                    </b-field>
                </b-field>

                <b-field>
                    <b-field>
                        <b-field label="Comentario">
                            <b-input v-model="deliveryAddress.remarks" placeholder=""></b-input>
                        </b-field>
                    </b-field>
                </b-field>

                <b-field grouped>
                    <b-field expanded
                             label="Teléfono"
                             :type="errors.has('phone') ? 'is-danger' : ''"
                             :message="errors.first('phone')">
                        <b-input name="phone"
                                 v-model="deliveryAddress.phone"
                                 v-validate="'required'">
                        </b-input>
                    </b-field>

                    <b-field expanded
                             label="Celular"
                             :type="errors.has('cellphone') ? 'is-danger' : ''"
                             :message="errors.first('cellphone')">
                        <b-input name="cellphone" v-model="deliveryAddress.cellphone" v-validate="'required'"></b-input>
                    </b-field>
                </b-field>
            </div>
            <div class="column">
                <google-map class="map" ref="map" name="example"></google-map>
            </div>
        </div>

        <div class="modal-footer field is-grouped is-grouped-right">
            <p class="control">
                <button class="button" @click.prevent="onCloseSelected">Cancelar</button>
                <a class="button is-primary" @click.prevent="onSaveSelected">Guardar</a>
            </p>
        </div>
    </section>
</template>

<script>
    /* global google */
    import GoogleMap from '../ui/GoogleMap';

    export default {
        name: 'DeliveryAddressCreate',
        props: ['active'],
        components: {
            GoogleMap
        },

        data() {
            return {
                addressUserInput: '',
                hasValidAddress: false,
                deliveryAddress: {
                    address: '',
                    location: null,
                    unit: '',
                    phone: '',
                    cellphone: '',
                    area: '',
                    postalCode: '',
                    city: '',
                    remarks: ''
                },
            }
        },

        computed: {
            canSubmit() {
                return this.hasValidAddress;
            }
        },

        mounted() {

        },

        methods: {
            onSaveSelected() {
                return this.validate().then(() => {
                    return this.$store.dispatch('customer/addShippingAddress', this.deliveryAddress);
                }).then((address) => {
                    this.$emit('saved', address);
                    return address;
                }).catch(error => {
                    if(error.code === 'error.zone.invalid') {
                        this.errors.add({ field: 'addressUserInput', msg: error.message });
                    } else if(error.type === 'error.validation') {
                        Object.keys(error.errors).forEach((key) => {
                            let value = error.errors[key];
                            this.errors.add({ field: key, msg: value });
                        });
                    }

                    throw error;
                });
            },

            onCloseSelected() {
                this.$emit('close');
            },

            validate() {
                if(!this.hasValidAddress) {
                    this.errors.add({ field: 'addressUserInput', msg: 'Debe ingresar una dirección válida' });

                    throw new Error();
                }

                return this.$validator.validate().then(result => {
                    if(!result)
                        throw new Error();
                });
            },

            onSearchAddress() {
                this.errors.clear();

                let address = this.$refs.address.value;

                let bounds = new google.maps.LatLngBounds(
                    new google.maps.LatLng(-35.068078, -59.219226),
                    new google.maps.LatLng(-34.260481, -57.673578)
                );

                let address_info = null;

                this.$refs.map.getAddressInfo({
                    address: address,
                    bounds: bounds,
                    componentRestrictions: {country: 'ar'}
                }).then((result) => {
                    address_info = result;
                    return this.$refs.map.getPlaceDetails(result.place_id);
                }).then((place_info) => {
                    this.$refs.map.clearMarkers();
                    this.$refs.map.setCenter(address_info.geometry.location);
                    this.$refs.map.setMarker(address_info.geometry.location);

                    // Fill in the form data
                    this.deliveryAddress.address = address_info.formatted_address;
                    this.deliveryAddress.location = address_info.geometry.location;

                    // If the search yielded some kind of place or establishment, let's add that info too.
                    this.deliveryAddress.place = null;
                    if(place_info.types) {
                        if(['point_of_interest', 'establishment', 'neighborhood'].some(r => place_info.types.includes(r))) {
                            this.deliveryAddress.place = place_info.name;
                        }
                    }

                    // additional address information
                    let components = {};
                    for(let i = 0; i < address_info.address_components.length; ++i) {
                        components[address_info.address_components[i].types[0]] = address_info.address_components[i].short_name;
                    }

                    this.deliveryAddress.area = components.political;
                    this.deliveryAddress.postalCode = components.postal_code;
                    this.deliveryAddress.city = components.administrative_area_level_1;

                    this.hasValidAddress = true;
                }).catch((err) => {
                    this.hasValidAddress = false;
                    this.errors.add({ field: 'addressUserInput', msg: 'No se puede encontrar la dirección' });
                });
            },
        }
    }
</script>

<style scoped>
    th {
        text-transform: capitalize;
    }

    .address-info {
        font-size: 0.9em;
        font-weight: bold;
    }

    .map {
        height: 100%;
    }
</style>